import { render } from "./ModalRecomendacionVerVideo.vue?vue&type=template&id=14458e46&scoped=true&ts=true"
import script from "./ModalRecomendacionVerVideo.vue?vue&type=script&lang=ts"
export * from "./ModalRecomendacionVerVideo.vue?vue&type=script&lang=ts"

import "./ModalRecomendacionVerVideo.vue?vue&type=style&index=0&id=14458e46&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14458e46"]])

export default __exports__